import moment from "moment";

export const modifyValuesForSerialization = values => {
  if (values.loanProceedAssumptions[0]) {
    values.loanProceedAssumptions[0].loanSpread = values.loanProceedAssumptions[0].loanSpread ? values.loanProceedAssumptions[0].loanSpread / 100 : null;
    values.loanProceedAssumptions[0].maxLTV = values.loanProceedAssumptions[0].maxLTV ? values.loanProceedAssumptions[0].maxLTV / 100 : null;
    values.loanProceedAssumptions[0].minDebtYield = values.loanProceedAssumptions[0].minDebtYield ? values.loanProceedAssumptions[0].minDebtYield / 100 : null;
    values.loanProceedAssumptions[0].UwRate = values.loanProceedAssumptions[0].UwRate ? values.loanProceedAssumptions[0].UwRate / 100 : null;
    values.loanProceedAssumptions[0].amortizationRate = values.loanProceedAssumptions[0].amortizationRate ? values.loanProceedAssumptions[0].amortizationRate / 100 : null;
    values.loanProceedAssumptions[0].closingCosts = values.loanProceedAssumptions[0].closingCosts ? values.loanProceedAssumptions[0].closingCosts / 100 : null;
  }

  if (values.targetedClosing) {
    values.targetedClosing = moment(values.targetedClosing).add(6, "hours");
  }

  return values;
};
